






















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mixins } from 'vue-class-component';

import NumberPad from "@/components/Money/NumberPad.vue";
import FormItem from "@/components/Money/FormItem.vue";
import Tags from "@/components/Money/Tags.vue";

import Tabs from "@/components/Tabs.vue";

import recordTypeList from '@/constants/recordTypeList'
import Dialog from "@/components/Dialog.vue";
import TagHelper from '@/mixins/TagHelper';

@Component({
  components: {
    NumberPad,
    FormItem,
    Tags,
    Tabs,
    Dialog,
  }
})
export default class Money extends mixins(TagHelper) {
  get recordList() {
    return this.$store.state.recordList
  }

  recordTypeList = recordTypeList

  isSelectTagVisible = false

  record: RecordItem = {
    tags: [],
    notes: "",
    type: "-",
    amount: 0,
    createdAt: ""
  };

  created() {
    this.$store.commit('fetchRecords')
  }

  saveRecord() {
    if (!this.record.tags || this.record.tags.length === 0) {
      return window.alert('请至少选择一个标签')
      // this.isSelectTagVisible = true
      // return
    }
    this.$store.commit('createRecord', this.record)
    window.alert('已保存')
    this.record.tags = []
    this.record.notes = ''
    this.record.amount = 0
  }

  confirmSelectTag () {
    this.isSelectTagVisible = false
  }

  cancelSelectTag () {
    this.isSelectTagVisible = false
  }
}
